import { Space, Switch } from "antd"
import { ButtonOptions } from "components/ui/buttons/ButtonOptions/ButtonOptions"
import { Dropdown } from "components/ui/dropdown/Dropdown"
import { InstructionsTableUtils } from "./InstructionsTableUtils"
import type { ColumnsType } from "antd/es/table"
import type { IInstructionsTable } from "types/table.type"
import style from "./InstructionsTable.module.scss"

const { sectionNumber } = style

type Props = {
	setEditInstructionModalOpen: () => void
	onDeleteClick: (id: number) => void
}

export const InstructionsTableColumns = ({ setEditInstructionModalOpen, onDeleteClick }: Props) => {
	const { dropdownHandle, onChangeSwitecherHandle, checkInstructionPending } = InstructionsTableUtils({
		setEditInstructionModalOpen,
		onDeleteClick,
	})

	const columns: ColumnsType<IInstructionsTable> = [
		{
			title: "SHORT FORM",
			dataIndex: "question",
			width: "70%",
			render: (item) => <div data-testid="short-form">{item}</div>,
		},
		{
			title: "SECTION NUMBER",
			dataIndex: "sections",
			render: (item) => (
				<div className={sectionNumber} data-testid="section-number">
					{item.map((subItem: string, index: number) => (
						<span key={index}>{subItem}</span>
					))}
				</div>
			),
		},
		{
			title: "ACTIVE",
			dataIndex: "active",
			render: (item) => (
				<div onClick={(e) => e.stopPropagation()} data-testid="active-switcher">
					<Switch
						checked={item.status === "active"}
						loading={checkInstructionPending(item.questionId)}
						onChange={(checked) => onChangeSwitecherHandle(item.questionId, checked)}
					/>
				</div>
			),
		},
		{
			title: "",
			dataIndex: "action",
			render: (item) => (
				<div onClick={(e) => e.stopPropagation()} data-testid="action-dropdown">
					<Dropdown items={dropdownHandle(item)}>
						<Space>
							<ButtonOptions />
						</Space>
					</Dropdown>
				</div>
			),
		},
	]

	return columns
}
